import axios from 'axios';
import {
    MDBAlert,
    MDBBtn,
    MDBCard,
    MDBCardBody,
    MDBInput
} from "mdb-react-ui-kit";

import PropTypes from 'prop-types';
import React, { useEffect, useState } from "react";

const EmailForm = ({  showEmailModal, setShowEmailModal, emailsId, setEmails, setIsEmailFormSubmitted, emailToUpdate, updateEmailId }) => {
    const baseUrl = process.env.REACT_APP_INVENTORY_URL;
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertColor, setAlertColor] = useState('');

    const initialFormValues = emailToUpdate ? [emailToUpdate ] : [{type: '', value: '' }];
    const [localEmails, setLocalEmails] = useState(initialFormValues);

    useEffect(() => {
        if (emailToUpdate) {
            setLocalEmails([emailToUpdate]);
        } else {
            setLocalEmails([{
                type: '',
                value: ''
            }]);
        }
    }, [emailToUpdate]);

    const addEmail = () => {
        setLocalEmails(prev => [...prev, {
            type: '',
            value: ''
        }]);
    };

    const removeEmail = (indexToRemove) => {
        setLocalEmails(prevEmails =>
            prevEmails.filter((_, index) => index !== indexToRemove)
        );
    };

    const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        const list = [...localEmails];
        list[index][name] = value;
        setLocalEmails(list);
    };

    const hasDuplicateEmailType = (emails) => {
        const types = emails?.map(email => email.type);
        return new Set(types).size !== types.length;
    };

    const handleFormSubmit = (event) => {
        if(emailsId!=='test'){
        event.preventDefault();
        if (hasDuplicateEmailType(localEmails)) {
            setAlertMessage('Duplicate email types are not allowed');
            setAlertColor('danger');
            setShowAlert(true);
            setTimeout(() => setShowAlert(false), 5000);
            return;
        }
        const axiosConfig = {
            method: showEmailModal ? 'put' : 'post',
            url: showEmailModal ? `${baseUrl}/emails/${emailsId}` : `${baseUrl}/emails`,
            data: localEmails
        };

        axios(axiosConfig)
            .then(response => {
                if (response.status === 200 || response.status === 201) {
                    showEmailModal ? setEmails(response.data) : setEmails(response.data.emailsSet);
                    !showEmailModal && updateEmailId(response.data.id);
                    setAlertMessage('Emails have been saved');
                    setAlertColor('success');
                    setShowAlert(true);
                    setTimeout(() => {
                        setShowAlert(false);
                        showEmailModal && setShowEmailModal(false);
                        !showEmailModal && setIsEmailFormSubmitted(true);
                        setLocalEmails([{
                            type: '',
                            value: ''
                        }]);
                    }, 2000);
                }
            })
            .catch(error => {
                console.error(error);
                setAlertMessage('An error occurred while saving the emails');
                setAlertColor('danger');
                setShowAlert(true);
                setTimeout(() => setShowAlert(false), 2000);
            });
        }
    };

    const isFormValid = () => {
        return localEmails?.every(email => email.type.trim() !== '' && email.value.trim() !== '');
    };
    

    return (
        <section className="grainy-gradient-intro " style={{ marginBottom: '20px' }}>
            <h5 className="display-8 fw-bold text-uppercase text-black mb-0 text-center" style={{ letterSpacing: '15px' }}> Email </h5>
            <hr className="hr" />
            <MDBCard>
                <MDBCardBody className="text-center pt-4">
                    <form onSubmit={handleFormSubmit}>
                        {localEmails?.map((email, index) => (
                            <div key={index}>
                                {localEmails?.length > 1 && (
                                    <MDBBtn className='me-2' type="button" onClick={() => removeEmail(index)}>
                                        Remove Email
                                    </MDBBtn>
                                )}
                                <MDBInput className="mb-4" label="Type *" name="type" value={email.type} onChange={(e) => handleInputChange(e, index)} required />
                                <MDBInput className="mb-4" label="Email *" name="value" value={email.value} type='email' onChange={(e) => handleInputChange(e, index)} />
                                {index < localEmails.length - 1 && <hr className="hr" />}
                            </div>
                        ))}
                        <div className="d-grid gap-2 d-md-block " style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }} >
                            <MDBBtn className='me-2' type="button" onClick={addEmail}>
                                Add Email
                            </MDBBtn>
                            <MDBBtn type="submit" disabled={!isFormValid()}>
                                Save
                            </MDBBtn>
                            {showEmailModal && <MDBBtn className='mx-2' color='danger' onClick={() => setShowEmailModal(false)}>close</MDBBtn>}
                        </div>
                    </form>
                </MDBCardBody>

                <MDBAlert open={showAlert}
                    color={alertColor}
                    autohide
                    width={800}
                    position="top-right"
                    offset={50}
                    delay={2000}
                    appendToBody
                >
                    {alertMessage}
                </MDBAlert>

            </MDBCard>
        </section>
    );
};

EmailForm.propTypes = {
   
    setShowEmailModal: PropTypes.func,
    showEmailModal: PropTypes.bool,
    emailsId: PropTypes.string,
    setEmails: PropTypes.func,
    emailToUpdate: PropTypes.object,
    updateEmailId: PropTypes.func,
    setIsEmailFormSubmitted: PropTypes.func,
}

export default EmailForm;
